import React, { useState } from 'react'
import StyledText from '../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../middleware/ThemeContext';
import { FieldLabel } from '../../../components/FormBuilder/FieldSettings/FieldSettingsModal';
import { SkeletonCell } from '../../../components/SkeletonCell';
import CustomInput from '../../../components/form/CustomInput';
import { TagChip, TagListContainer } from './PagesComponents/NewPageModal';
import CrossIcon from '../../../assets/icons/CrossIcon';
import CustomTextArea from '../../../components/form/CustomTextArea';
import { CreateFormTheme } from '../../../utils/themes';
import { CardContainer } from './SettingsComponents/CookieConsent';
import IdeaIcon from '../../../assets/icons/IdeaIcon';
import { useCreateWebsiteMutation } from '../../../api/pageBuilderApiSlice';

interface SeoSettingProps {
    metaTags: string[];
    setMetaTags: React.Dispatch<React.SetStateAction<string[]>>;

    newMetaTag: string;
    setNewMetaTag: React.Dispatch<React.SetStateAction<string>>;

    description: string;
    setDescription: React.Dispatch<React.SetStateAction<string>>;
    companyLoading?: boolean
}

const SeoSetting: React.FC<SeoSettingProps> = ({
    metaTags,
    setMetaTags,
    newMetaTag,
    setNewMetaTag,
    description,
    setDescription,
    companyLoading
}) => {
    const { theme } = useTheme();
    const getRandomWidth = () => {
        const min = 100;
        const max = 130;
        return `${Math.floor(Math.random() * (max - min + 1)) + min}px`;
    };
    return (
        <div className='d-flex gap-4' style={{ height: 'calc(100vh - 242px)', padding: "20px 35px", background: theme.CorporateTheme.colors.background, border: `1px solid ${theme.CorporateTheme.colors.border}`, borderRadius: '10px' }}>
            <div className='w-100'>
                <div>

                    <FieldLabel theme={theme}>
                        Meta Tags
                    </FieldLabel>
                    {companyLoading ?
                        <SkeletonCell height={'40px'} width={"100%"} />

                        : <CustomInput
                            type="text"
                            placeholder="Enter tags here"
                            value={newMetaTag}
                            onChange={(value: string) => setNewMetaTag(value)}

                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && newMetaTag.trim()) {
                                    e.preventDefault();
                                    if (!metaTags.includes(newMetaTag.trim())) {
                                        setMetaTags([...metaTags, newMetaTag.trim()]);
                                    }
                                    setNewMetaTag('');
                                }
                            }}

                        />}
                    <TagListContainer className='mb-4'>
                        {companyLoading ?

                            Array.from({ length: 5 }).map((_, index) => (
                                <SkeletonCell key={index}
                                    height={'36px'} width={getRandomWidth()} className='rounded-pill' />
                            ))


                            : <>
                                {metaTags.map((tag, index) => (
                                    <TagChip
                                        key={index}
                                        style={{ gap: '10px', backgroundColor: theme.CorporateTheme.colors.background, border: `1px solid ${CreateFormTheme.colors.inputBorders}`, padding: '8px 15px' }}
                                    >
                                        <StyledText fontWeight={500} fontSize='12px' textColor={theme.CorporateTheme.colors.graniteGrey}>{tag}</StyledText>

                                        <div className='d-flex align-items-center justify-content-center' onClick={() => setMetaTags(metaTags.filter((_, i) => i !== index))}>
                                            <CrossIcon size={18} color={theme.CorporateTheme.colors.graniteGrey} />
                                        </div>
                                    </TagChip>
                                ))}
                            </>}
                    </TagListContainer>
                </div>
                <div >
                    <FieldLabel theme={theme}>Meta Description</FieldLabel>
                    {companyLoading ?
                        <SkeletonCell 
                            height={'70px'} width={"100%"} />
                        : <CustomTextArea
                            type="textarea"
                            placeholder="Enter description here"
                            value={description}
                            onChange={(value: string) => setDescription(value)}

                        />}
                </div>
            </div>
            <div>
                <CardContainer theme={theme} style={{ width: 348, marginTop: 35 }}>
                    <div className='d-flex gap-2'>
                        <div><IdeaIcon /></div>
                        <StyledText fontStyle='italic' fontSize={'14px'} fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>The SEO settings, such as meta tags or meta descriptions, that you add here will be applied to the overall website. However, if the user adds meta tags and a meta description on a specific page, then those page-level settings will apply only to that page, while the rest of the website will continue to follow the global settings.</StyledText>
                    </div>
                </CardContainer >
            </div>
        </div>
    )
}

export default SeoSetting
